import { createSlice } from "@reduxjs/toolkit";
import {
  DecisionWithLinking,
  TRWithDatapieceExtra,
  GetReportDataParams,
  DecisionInsights,
} from "../../pages/DecisionHub/interfaces";
import { Company } from "../../interfaces/interfaces";

interface INITIAL_STATE {
  decisions: DecisionWithLinking[];
  insights: DecisionInsights[];
  insightsFromSocket: DecisionInsights[];
  companiesForAgency: Company[];
  topReports: TRWithDatapieceExtra[];
  selectedCompanyForAgency: { name: string; id: number };
  selectedReport: GetReportDataParams;
  forceRefresh: boolean;
  refreshMetricsAndIdeas: boolean;
  refreshInsightsFeed: boolean;
}

const INITIAL_STATE: INITIAL_STATE = {
  decisions: [],
  insights: [],
  insightsFromSocket: [],
  companiesForAgency: [],
  topReports: [],
  selectedCompanyForAgency: null,
  selectedReport: null,
  forceRefresh: false,
  refreshMetricsAndIdeas: false,
  refreshInsightsFeed: false,
};

const decisionHub = createSlice({
  name: "decisionHub",
  initialState: INITIAL_STATE,
  reducers: {
    setDecisions: (state, actions) => {
      state.decisions = actions.payload;
    },
    setInsightsFromSocket: (state, actions) => {
      state.insightsFromSocket = actions.payload;
    },
    setInsights: (
      state,
      actions: {
        payload: {
          data: DecisionInsights[];
        };
        type: string;
      },
    ) => {
      state.insights = actions.payload.data;
    },
    setCompaniesForAgency: (state, actions) => {
      state.companiesForAgency = actions.payload;
    },
    setSelectedCompanyForAgency: (state, actions) => {
      state.selectedCompanyForAgency = actions.payload;
    },
    setSelectedReport: (
      state: INITIAL_STATE,
      actions: { payload: GetReportDataParams },
    ) => {
      state.selectedReport = actions.payload;
    },
    setForceRefresh: (state: INITIAL_STATE, actions: { payload: boolean }) => {
      state.forceRefresh = actions.payload;
    },
    setTopReports: (state, actions) => {
      state.topReports = actions.payload;
    },
    setRefreshMetricsAndIdeas: (state, actions) => {
      state.refreshMetricsAndIdeas = actions.payload;
    },
    setRefreshInsightsFeed: (state, actions) => {
      state.refreshMetricsAndIdeas = actions.payload;
    },
  },
});

export const {
  setDecisions,
  setCompaniesForAgency,
  setSelectedCompanyForAgency,
  setSelectedReport,
  setTopReports,
  setForceRefresh,
  setInsights,
  setInsightsFromSocket,
  setRefreshMetricsAndIdeas,
  setRefreshInsightsFeed,
} = decisionHub.actions;

export const decisionHubReducer = decisionHub.reducer;
